import React from 'react';
import AddNewClassified from './AddNewClassified'
import AddBreadCrumb from './AddBreadCrumb';

function AddClassifiedPage() {
    return ( 
        <div className = "container-fluid">
        <AddBreadCrumb />
        <AddNewClassified />
        </div>
     );
}

export default AddClassifiedPage;